import { Component } from '@angular/core';
import { environment } from 'projects/whocan-app/src/environments/environment';
import { ResponsiveService } from '../../../shared/services/responsive.service';
import { RouteContextService } from '../../../shared/services/route-context.service';
import { TranslationGeneralService } from '../../../shared/translation/translation.general.service';
import { UIMesageService } from '../../../shared/services/ui-message.service';
import { AuthService } from '../../../user/auth.service';
import { UserService } from '../../../user/user.service';
import { HeaderService } from '../../shared/poll-header/header.service';
import { NavigationService } from '../../core/navigation.service';
import { CommonModule } from '@angular/common';
import { LogoComponent } from '../../../shared/logo/logo.component';
import { RouterModule } from '@angular/router';
import { NavMenuButtonComponent } from '../../../shared/menu-button/menu-button.component';
import { AuthErrorService } from '../../../user/auth-error.service';
import { TranslateMigratedPipe } from '../../../shared/translation/trans-migrated.pipe';
import { NavCreatePollButtonComponent } from '../../../app-shell/nav/create-poll-button/create-poll-button.component';
import { PollService } from '../../core/poll.service';

@Component({
    selector: 'vote-bar-invite',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        LogoComponent,
        NavMenuButtonComponent,
        TranslateMigratedPipe
    ],
    templateUrl: './vote-bar-invite.component.html',
    styleUrls: ['./vote-bar-invite.component.scss'],
})
export class VoteBarInviteComponent {
    public qrCode: string = null;

    constructor(
        public authService: AuthService,
        public userService: UserService,
        private uiMessage: UIMesageService,
        public responsiveService: ResponsiveService,
        public headerService: HeaderService,
        public routeContextService: RouteContextService,
        public navigationService: NavigationService,
        public trans: TranslationGeneralService,
        private authErrorService: AuthErrorService,
        public pollService: PollService
    ) { }



    public getHomeButtonName(): string {
        return environment.home_button_label_short;
    }

    public async openMySurveys() {
        this.navigationService.navigate(this.trans.getRoutePath('myPolls'));
    }

    get disableCreatePollButton(): boolean {
        if (this.routeContextService.id === 'createPoll') {
            return true;
        }
        return false;
    }

    navigateToChoosePollTemplate(): void {
        this.navigationService.navigateChoosePollTemplate();
    }
}
